import React from 'react';
import { Columns3Icon, ShieldCheckIcon, ShuffleIcon } from 'lucide-react';
const screenshotUrl = 'https://assets.cdn.filesafe.space/mAYT5j2uK2pp9sMVfZ1o/media/2a4b142b-a83a-4278-905d-14abba876228.png';
const points = [{
  label: 'Three looks for every section',
  icon: Columns3Icon
}, {
  label: 'Pick a whole page or mix and match',
  icon: ShuffleIcon
}, {
  label: 'You approve before anything goes live',
  icon: ShieldCheckIcon
}];
export function PickYourPhotos() {
  return <section aria-labelledby="pick-your-photos" className="border-t border-gray-200 bg-white px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1010" data-mp="3t7ohzrb46h96">
      <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1011" data-mp="3o8trs4athqf1">Your photos, your choice</p>
      <h2 id="pick-your-photos" className="mt-3 max-w-[26ch] text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-1012" data-mp="3jb1ueurelc3g">
        See three looks side by side. Pick the one you love.
      </h2>
      <p className="mt-5 max-w-[72ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-1013" data-mp="yij2b3jn4rfr">
        Finding the right photos is usually the slowest part of building a website. We make it easy. For each part of
        your website, we show you three different looks side by side, using professional stock photos and custom images
        made for your business. Pick a whole page in one click, or mix and match section by section. Nothing goes on your
        website until you approve it.
      </p>

      <figure className="mt-12" data-id="element-1014" data-mp="1m7k96mctruix">
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-xl" data-id="element-1015" data-mp="1m6izal7jpe2s">
          <div className="flex items-center gap-1.5 border-b border-gray-200 bg-gray-50 px-4 py-3" aria-hidden="true" data-id="element-1016" data-mp="18ax2vsyzfs0c">
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-1017" data-mp="3sz2zwaydsup5" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-1018" data-mp="3sxrxofkl3v05" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-1019" data-mp="wbs9e4ki6w0" />
          </div>
          <img src={screenshotUrl} alt="Three website looks shown side by side to choose from" loading="lazy" decoding="async" className="block h-auto w-full" data-id="element-1020" data-mp="23i7hom9der0l" />
        </div>
        <figcaption className="mt-4 text-[clamp(0.9375rem,1vw,1.125rem)] text-gray-600" data-id="element-1021" data-mp="1tq1pbbf7i7kv">
          Example: three looks for a bakery’s home page. Choose one, or mix and match by section.
        </figcaption>
      </figure>

      <ul className="mt-10 grid gap-5 sm:grid-cols-3" data-id="element-1022" data-mp="1fsd5m6wvl6he">
        {points.map(point => <li key={point.label} className="flex items-center gap-3" data-id="element-1023" data-mp="1fupuz54yqj4h">
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-brand-tint text-brand-red" data-id="element-1024" data-mp="1atscerg1jn2g">
              <point.icon className="h-5 w-5" aria-hidden="true" data-id="element-1025" data-mp="15wjveu6mpp2s" />
            </span>
            <span className="font-semibold leading-snug text-brand-black" data-id="element-1026" data-mp="35574vg0fs0lw">{point.label}</span>
          </li>)}
      </ul>
    </section>;
}